import 'normalize.css';
import React from 'react';
import { ModalProvider } from 'react-modal-hook';
import { Route } from 'react-router-dom';
import InvitationGift from '../InvitationGift';
import InvitationList from '../InvitationGift/List';
import InvitationShareImage from '../InvitationGift/ShareImage';
import Subscribe from '../Subscribe';
import Withdraw from '../Withdraw';
import WithdrawSuccess from '../Withdraw/Success';
import './index.scss';

// import Vconsole from 'vconsole'
// const vconsole = new Vconsole()

export default function App() {
  return (
    <ModalProvider>
      <Route path="/subscribe/" component={Subscribe} />
      <Route path="/invitation_gift/" exact={true} component={InvitationGift} />
      <Route path="/invitation_gift/list/" component={InvitationList} />
      <Route
        path="/invitation_gift/share_image/"
        component={InvitationShareImage}
      />
      <Route path="/withdraw/" exact={true} component={Withdraw} />
      <Route path="/withdraw/success" component={WithdrawSuccess} />
    </ModalProvider>
  );
}
